(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('FirstNameDialogController', FirstNameDialogController);

    FirstNameDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FirstName'];

    function FirstNameDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FirstName) {
        var vm = this;
        vm.firstName = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:firstNameUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.firstName.id !== null) {
                FirstName.update(vm.firstName, onSaveSuccess, onSaveError);
            } else {
                FirstName.save(vm.firstName, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
